import { withInstall as t } from "../../utils/with-install.js";
import o from "./alert.vue.js";
/* empty css           */
const p = t(o);
export {
  p as ApAlert,
  p as default
};
